module.exports = __webpack_public_path__ + "media/images/favicons_staging/apple-touch-icon-120x120-precomposed-44aaf1278cfd9923675e0672309da2db.png";